module.exports = __webpack_public_path__ + "static/img/en22.b147137.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/en22.jpg
// module id = b90S
// module chunks = 1